<template>
    <el-card class="box-card" style="border: 0vh;">
        <el-col :span="5">
          <el-row v-for="o in clientasset" :key="o.id" class="text item">
            {{ o.name }}: {{ o.value }}
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row v-for="o in clientasset" :key="o.id" class="text item">
            {{ o.name }}: {{ o.value }}
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row v-for="o in clientasset" :key="o.id" class="text item">
            {{ o.name }}: {{ o.value }}
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row v-for="o in clientasset" :key="o.id" class="text item">
            {{ o.name }}: {{ o.value }}
          </el-row>
        </el-col>
    </el-card>
</template>

<script>
export default {
    name: "ClientBehaviour",
    data(){
        return {
            clientasset: [
                {
                    id: 1,
                    name: '在手订单',
                    value: 1000.00
                },
                 {
                    id: 1,
                    name: '在手订单',
                    value: 1000.00
                },
                 {
                    id: 1,
                    name: '在手订单',
                    value: 1000.00
                },
                 {
                    id: 1,
                    name: '在手订单',
                    value: 1000.00
                }
            ]
        }
    }
}

</script>
<style scoped>
  .text {
    font-size: 14px;
  }

  .item {
    padding: 0 0;
  }

  .box-card {
    width: 100%;
  }
</style>